import 'i18next';
import { IsNotEmpty, MaxLength, MinLength } from 'class-validator';

import { t } from '@app-velocity/i18n';

export class TeamUpdateDto {
  @IsNotEmpty({
    message: t('teams:validation.name_cannot_be_empty'),
  })
  @MinLength(3, {
    message: t('teams:validation.name_too_short', {
      minLength: 3,
    }),
  })
  @MaxLength(50, {
    message: t('teams:validation.name_too_long', {
      maxLength: 50,
    }),
  })
  name = '';
}
